/**
 * RTWO Asset & Token Engine — Null Storage Adapter
 */

import type { AssetId } from '../domain-models';
import type { IStorageAdapter, StorageAdapterStatus } from './storage-adapter-interface';

export class NullStorageAdapter implements IStorageAdapter {
  readonly adapterId = 'null-storage-adapter';
  readonly adapterName = 'Null Storage Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): StorageAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async configureMetadata(_assetId: AssetId, _metadataReference: string, _schemaVersion: string) {
    return null;
  }
}
